import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 28 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.8, delay, ease: [0.2, 0.7, 0.2, 1] }}
  >
    {children}
  </motion.div>
);

export const Logo = ({ size = 48, className = "" }) => (
  <img
    src="/brand/logo.png"
    alt="Yeni Mercan Restoran logosu"
    width={size}
    height={size}
    className={`rounded-full ${className}`}
    style={{ width: size, height: size }}
  />
);

export const SectionTitle = ({ eyebrow, title, light = false, className = "" }) => (
  <div className={className}>
    <p className="eyebrow mb-4">{eyebrow}</p>
    <h2
      className={`font-serif-ym text-4xl sm:text-5xl font-semibold leading-[1.05] ${light ? "text-[#1A1513]" : "text-[#FDFBF7]"}`}
    >
      {title}
    </h2>
  </div>
);
